export default "__VITE_ASSET__Buxa9yGS__"